/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventaistartsubmit3Inputs */

const en_eventaistartsubmit3 = /** @type {(inputs: Eventaistartsubmit3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill in`)
};

const de_eventaistartsubmit3 = /** @type {(inputs: Eventaistartsubmit3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausfüllen`)
};

/**
* | output |
* | --- |
* | "Fill in" |
*
* @param {Eventaistartsubmit3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventaistartsubmit3 = /** @type {((inputs?: Eventaistartsubmit3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventaistartsubmit3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventaistartsubmit3(inputs)
	return de_eventaistartsubmit3(inputs)
});
export { eventaistartsubmit3 as "eventAiStartSubmit" }